/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  playground({ assistantId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }

  generateInstructions({ conversationHistory, userInput }) {
    return axios.post(`${this.url}/generate_instructions`, {
      conversation_history: conversationHistory,
      user_input: userInput,
    });
  }
}

export default new CaptainAssistant();
